import { DraftDocument } from "src/app/backend/models/draft-document";
import { getDatabase } from "src/app/repositories/app-db";

export class DraftDocumentRepository {
  readonly #db = getDatabase();

  async create(draftDocument: DraftDocument): Promise<DraftDocument> {
    await this.#db.draftDocuments.add(draftDocument);
    return draftDocument;
  }

  async loadById(id: string): Promise<DraftDocument | undefined> {
    return await this.#db.draftDocuments.get(id);
  }

  async update(draftDocument: DraftDocument): Promise<void> {
    await this.#db.draftDocuments.update(draftDocument.id, draftDocument);
  }

  async delete(id: string): Promise<void> {
    await this.#db.draftDocuments.delete(id);
  }
}
